import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { LiftOperatorPageContent } from '@/pageContents/liftOperatorsContent/LiftOperatorPageContent';
import { Permission } from '@/models/user';

const LiftOperatorsPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>Bergbahnen | Starjack Backoffice</Helmet>

            <LiftOperatorPageContent />
        </>
    );
};

LiftOperatorsPage.isProtected = true;
LiftOperatorsPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
LiftOperatorsPage.permissions = [Permission.ADMIN];

export default LiftOperatorsPage;
